module.exports = __webpack_public_path__ + "img/xag-slogan.599d4ed9.png";